import Request from "../model/Request";
import Response from "../model/Response";
import {RestClient} from "../util/RestClient";
import {Config} from "../util/Config";
import ProductOrderResponse from "../model/productOrder/ProductOrderResponse";
import ProductOrderProfitOverviewResponse from "../model/productOrder/ProductOrderProfitOverviewResponse";
import ProductOrderAttachmentResponse from "../model/productOrder/ProductOrderAttachmentResponse";

export module ProductOrderService {

    export async function get(
        from: number,
        to: number,
        clientId: string,
    ): Promise<Response<ProductOrderResponse[]>> {
        const url = Config.get("GET_PRODUCT_ORDER_URL", {
            from,
            to,
            clientId
        });
        const request = new Request(url);
        const response = await RestClient.get(request);
        if (response.success) {
            const resultData = response.data;
            const itens = resultData.map((t: any) => new ProductOrderResponse(
                t.id,
                t.orderNumber,
                t.serviceName,
                t.totalToPay,
                t.status,
                t.contactId,
                t.contactName,
            ));
            return new Response<ProductOrderResponse[]>(true, itens, response.error, response.status);
        }
        return new Response<ProductOrderResponse[]>(false, undefined, response.error, response.status);
    }
    
    export async function addComment(deliveryOrderId: string, comment: string): Promise<Response<any>> {
        const url = Config.get("ADD_DELIVERY_COMMENT_URL", {
            id: deliveryOrderId
        });
        const request = new Request(url, { comment: comment ? comment : '' });
        return await RestClient.post(request);
    }

    export async function updateObservations(deliveryOrderId: string, observations: string): Promise<Response<any>> {
        const url = Config.get("UPDATE_DELIVERY_OBSERVATIONS_URL", {
            id: deliveryOrderId
        });
        const request = new Request(url, { observations: observations ?? '' });
        return await RestClient.put(request);
    }

    export async function removeBatch(productOrdersIds: string[]): Promise<Response<any>> {
        const url = Config.get("REMOVE_PRODUCT_ORDERS_URL", {ids: productOrdersIds});
        const request = new Request(url);
        return await RestClient.remove(request);
    }

    export async function recalculateServiceCost(productOrdersIds: string[]): Promise<Response<any>> {
        const url = Config.get("RECALCULATE_PRODUCT_ORDERS_SERVICE_COST_URL");
        const request = new Request(url, productOrdersIds);
        return await RestClient.put(request);
    }

    export async function getProfitOverview(
        from: number,
        to: number
    ): Promise<Response<ProductOrderProfitOverviewResponse>> {
        const url = Config.get("GET_PRODUCT_ORDER_PROFIT_OVERVIEW", { from, to });
        const request = new Request(url);
        const response = await RestClient.get(request);
        if (response.success) {
        const t = response.data;
        if (t) {
            const responseObject = new ProductOrderProfitOverviewResponse(
                t.totalPurchaseCost,
                t.totalServiceCost,
                t.totalProfit,
                t.ordersAmount,
            );
            return new Response<ProductOrderProfitOverviewResponse>(
                true,
                responseObject,
                response.error
            );
        }
        }
        return new Response<ProductOrderProfitOverviewResponse>(
            true,
            undefined,
            response.error,
            response.status
        );
    }

    export async function getAttachments(id: string): Promise<Response<ProductOrderAttachmentResponse[]>> {
        const url = Config.get("GET_PRODUCT_ORDER_ATTACHMENTS_URL", {id});
        const request = new Request(url)
        const response = await RestClient.get(request);
        if (response.success) {
            const comments = response.data;
            if (comments) {
                const commentsREsult = comments.map((t: ProductOrderAttachmentResponse) => new ProductOrderAttachmentResponse(
                    t.id,
                    t.productOrderId,
                    t.image,
                    t.type,
                    t.description,
                    t.userId,
                    t.createdAt
                ))
                return new Response<ProductOrderAttachmentResponse[]>(true, commentsREsult, response.error);
            }
        }
        return new Response<ProductOrderAttachmentResponse[]>(true, undefined, response.error, response.status);
    }

}